<div class="w-full px-2 lg:px-4 bg-white rounded-lg py-2 mt-2">
  <div class="sm:flex items-center justify-between gap-2">
    <p class="text-0d5bab font-bold text-[13px] sm:text-sm lg:text-base xl:text-lg capitalize mb-2 sm:mb-0">Profit &
      Loss</p>
    <div class="flex flex-wrap items-center justify-start gap-2">
      <!-- views -->
      <select
        class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium ps-2 pe-7 py-1.5"
        [(ngModel)]="selectedView">
        <option value="summary">Summary</option>
        <option value="detailed">Detailed</option>
      </select>
      <!-- all firms -->
      <select class="bg-white border border-d9d9d9 rounded-md ps-1 2xl:ps-2 pe-7 py-2 text-[13px] text-383838"
        [(ngModel)]="filters.firm_id" (change)="onFilterChange()">
        <option *ngIf="firms.length > 1" value="">All Firms</option>
        <option *ngFor="let firm of firms" [value]="firm.id">
          {{ firm.name }}
        </option>
      </select>
      <!-- Date From -->
      <div class="relative"><input type="date" [(ngModel)]="filters.from_date" (change)="onFilterChange()"
          class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner"><label
          for=""
          class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">From</label>
      </div>
      <!-- Date To -->
      <div class="relative"><input type="date" [(ngModel)]="filters.to_date" (change)="onFilterChange()"
          class="block px-1 py-2 w-full text-[13px] text-383838 font-normal bg-white rounded-md border border-d9d9d9 appearance-none focus:outline-none focus:ring-0 focus:border-c19725 peer no-spinner"><label
          for=""
          class="absolute text-[13px] text-9ca0a9 duration-300 transform -translate-y-4 scale-75 top-2 z-0 origin-left bg-white px-1 peer-focus:px-1 peer-focus:text-c19725 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 rtl:peer-focus:translate-x-1/4 rtl:peer-focus:left-auto start-1">To</label>
      </div>
      <!-- Export Button -->
      <button (click)="exportToExcel()"
        class="cursor-pointer capitalize rounded-md border border-898989 bg-white text-898989 text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center hover:shadow-sm transition">Export</button>
      <!-- Print Button -->
      <button (click)="printProfitLoss()"
        class="cursor-pointer capitalize rounded-md border border-0d5bab bg-e7eefb text-0d5bab text-[13px] lg:text-[15px] font-medium px-2 lg:px-4 py-2 text-center">Print</button>
    </div>
  </div>

  <div class="w-full mt-4 space-y-2">
    <div class="w-full mt-4 space-y-2">
      @if (selectedView === 'detailed') {
      <app-profit-loss1 #detailedView [filters]="filters"></app-profit-loss1>
      }

      @if (selectedView === 'summary') {
      <app-profit-loss2 #summaryView [filters]="filters"></app-profit-loss2>
      }
    </div>
  </div>
</div>